import {api} from "../../services";
import Swal from "sweetalert2";

const reports = {
  state: {
    pagination: [],
    data: [],
    source: {},
    infos: [],
    graph: {
      series: [],
      labels: [],
    },
    search: {
      channel_id: null
    },
    watch: 0,
    nps_channel_pagination: [],
    nps_department_pagination: [],
    nps_operator_pagination: [],
    campaign_tracking: null,
    report_campaign_tracking: {
      // leads: null,
      // views: null,
      // unique: null,
      chart_day: [],
      chart_browser: [],
      chart_os: [],
      chart_device: [],
      chart_city: [],
      chart_state: [],
      chart_country: []
    },
    report_campaign_tracking_data: {
      id: null,
      channel_id: null,
      user_id: null,
      tags_id: [],
      status_key: null,
      type_key: null,
      text: null,
      file: null,
      data: {
        title: null,
        fb_pixel: null,
        tracking: true,
        google_analytics: null,
        google_tag_manager: null
      },
      finished_at: null,
      scheduled_at: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      created: null,
      finished: null,
      go_send_campaign: true,
      go_create_campaign: true,
      mime_type_file: null,
      metrics: {
        total: null,
        pending: null,
        done: null,
        percent: null
      },
      scheduled: null,
      status: null,
      url_file: null,
      url_thumbnail_file: null
    },
    report_webhook: [],
    filter_report_chatbot: {
      channel_id: null,
      initial_date: null,
      final_date: null,
      bot_selected_id: null
    },
    report_main_menu_chatbot_clicks: [],
    report_submenu_chatbot_clicks: [],
    search_report_chatbot: false
  },
  getters: {},
  mutations: {
    SET_REPORTS_NPS_CHANNEL(state, payload) {
      state.nps_channel_pagination = payload
      // this.dispatch("getTicketsData", payload.data);
    },
    SET_REPORTS_NPS_DEPARTMENT(state, payload) {
      state.nps_department_pagination = payload
      // this.dispatch("getTicketsData", payload.data);
    },
    SET_REPORTS_NPS_OPERATOR(state, payload) {
      state.nps_operator_pagination = payload
      // this.dispatch("getTicketsData", payload.data);
    },
    SET_CAMPAIGN_TRACKING(state, payload) {
      state.campaign_tracking = payload
    },
    SET_REPORT_CAMPAIGN_TRACKING(state, payload) {
      state.report_campaign_tracking = payload
    },
    SET_REPORT_CAMPAIGN_TRACKING_DATA(state, payload) {
      state.report_campaign_tracking_data = payload
    },
    SET_REPORT_WEBHOOK(state, payload) {
      state.report_webhook = payload
    },
    SET_REPORT_MAIN_MENU_CHATBOT(state, payload) {
      state.report_main_menu_chatbot_clicks = payload
    },
    SET_REPORT_SUBMENU_CHATBOT(state, payload) {
      state.report_submenu_chatbot_clicks = payload
    },
  },
  actions: {
    // Export Reports
    exportEmailsExcel(context, payload = {}) {
      api.post('histories/download/email', payload).then(() => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_951') }`,
          `${ context.rootGetters.getTranslations('expression_952') }`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    exportSmsExcel(context, payload = {}) {
      api.post('histories/download/sms', payload).then(() => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_951') }`,
          `${ context.rootGetters.getTranslations('expression_952') }`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    exportHsmExcel(context, payload = {}) {
      api.post('histories/download/hsm', payload).then(() => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_951') }`,
          `${ context.rootGetters.getTranslations('expression_952') }`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    exportVoipExcel(context, payload = {}) {
      api.post('histories/download/voip', payload).then(() => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_951') }`,
          `${ context.rootGetters.getTranslations('expression_952') }`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    exportNpsExcel(context, payload = {}) {
      api.post('tickets/survey/download', payload).then(() => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_951') }`,
          `${ context.rootGetters.getTranslations('expression_952') }`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },

    // Requests
    getHistoriesNpsChannel(context, payload) {
      api.get(`tickets/survey/channel`, {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_NPS_CHANNEL", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesNpsDepartment(context, payload) {
      api.get(`tickets/survey/department`, {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_NPS_DEPARTMENT", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesNpsOperator(context, payload) {
      api.get(`tickets/survey/operator`, {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_NPS_OPERATOR", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getReportCampaignTracking(context, payload) {
      api.get(`/campaigns/report_link/${payload}`).then(response => {
        // TODO: ALTERARR
        context.commit("SET_REPORT_CAMPAIGN_TRACKING", response.data);
        this.dispatch('getReportCampaignTrackingData', payload);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getReportCampaignTrackingData(context, payload) {
      api.get(`/campaigns/${payload}`).then(response => {
        context.commit("SET_REPORT_CAMPAIGN_TRACKING_DATA", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    resendHistoryWebhook(context, payload) {
      api.post(`histories/webhook/resend`, payload).then(() => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_1216') }`,
          `${ context.rootGetters.getTranslations('expression_1217') }`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    /*Exportar*/
    getReportExportChatBot(context, payload) {
      api.get(`/reports-chatbot/export`, { params: payload }).then(response => {
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_1261') }`,
          `${ response.data.message }`,
          'info'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    /*Main menu*/
    getReportMainChatBot(context, payload) {
      api.get(`/reports-chatbot/get-main-menu-clicks`, { params: payload }).then(response => {
        context.commit("SET_REPORT_MAIN_MENU_CHATBOT", response.data);
        this.dispatch('stopLoading');
        window.VueComponent.$root.$emit('getReportChatBot');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    /*Submenu*/
    setReportSubmenuChatBot(context, payload) {
      api.get(`/reports-chatbot/set-sub-option`, { params: payload }).then(response => {
        context.commit("SET_REPORT_SUBMENU_CHATBOT", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default reports;
